import { NavLink, Link } from 'react-router-dom';
import { cn } from '../../lib/utils';
import { useAuthStore } from '../../store/authStore';
import apiClient from '../../lib/api/client';
import { useNavigate } from 'react-router-dom';
import { useActivity } from '../../hooks/useStatistics';
import { Karti } from '../brand/Karti';
import { activityContext, useKartiMessage } from '../../lib/karti';

const navItems = [
  { to: '/app/dashboard', label: 'Heute', n: '01' },
  { to: '/app/courses', label: 'Kurse', n: '02' },
  { to: '/app/statistics', label: 'Statistik', n: '03' },
  { to: '/app/profile', label: 'Profil', n: '04' },
];

export default function Sidebar() {
  const { user, clearAuth } = useAuthStore();
  const navigate = useNavigate();
  const { data: activity } = useActivity();
  const kartiMsg = useKartiMessage('sidebar', activityContext(activity));

  const handleLogout = async () => {
    try {
      await apiClient.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      clearAuth();
      navigate('/login');
    }
  };

  return (
    <aside className="sticky top-0 hidden h-screen w-64 shrink-0 flex-col border-r-[2.5px] border-ink bg-paper p-5 lg:flex">
      <Link to="/" className="mb-8 flex items-center gap-3">
        <div className="flex h-11 w-11 -rotate-3 items-center justify-center rounded-tile border-2.5 border-ink bg-marker font-extrabold shadow-hard">
          <span className="text-xl">V</span>
        </div>
        <div>
          <div className="text-lg font-extrabold leading-none tracking-tight">Voc7</div>
          <div className="label-mono mt-1 !text-[10px]">7-Phasen-System</div>
        </div>
      </Link>

      <nav className="flex-1">
        <ul className="space-y-3">
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'press flex h-12 items-center gap-3 rounded-btn border-2.5 border-ink px-4 text-[15px] font-bold',
                    isActive
                      ? 'bg-ink text-paper shadow-hard-ink'
                      : 'bg-cream text-ink shadow-hard hover:bg-white'
                  )
                }
              >
                <span className="font-mono text-xs opacity-70">{item.n}</span>
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="mb-4 flex items-end gap-2" aria-live="polite">
        <Karti size={48} mood={kartiMsg.mood} />
        <p className="relative mb-2 flex-1 rounded-tile border-2 border-ink bg-cream px-2.5 py-1.5 text-xs font-bold leading-snug">
          {kartiMsg.text}
        </p>
      </div>

      <div className="border-t-[1.5px] border-divider pt-4">
        <div className="label-mono">Angemeldet</div>
        <div className="mb-3 truncate text-base font-bold">{user?.displayname || user?.nickname}</div>
        <button
          onClick={handleLogout}
          className="press h-10 w-full rounded-tile border-2 border-ink bg-cream px-3 text-sm font-bold shadow-hard-sm"
        >
          Abmelden
        </button>
      </div>
    </aside>
  );
}
